import $ from 'jquery';
import _ from 'lodash';
import cx from '../utils/cx.js';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import GalleryStore from '../stores/GalleryStore';
import GalleryBoxMain from './gallery/GalleryBoxMain.react';
import GalleryBoxThumbs from './gallery/GalleryBoxThumbs.react';
import Loader from './misc/Loader.react';

const ReactPropTypes = PropTypes;

function getStateFromStores() {
  return {
    load: GalleryStore.getLoad(), // info par datu ielādi
  };
}

class GalleryApp extends React.Component {
	static propTypes = {
	  onClose: ReactPropTypes.func,
	};

	static defaultProps = {
	  onClose: null,
	  showReportButton: true,
	  showLikeButton: true,
	  showComplimentButton: true,
	};

	constructor(props) {
	  super(props);
	  const store = getStateFromStores();
	  const additional = {
	    mainHeight: 0,
	    thumbs: true,
	  };

	  this.state = _.assign(store, additional);
	}

	componentDidMount() {
	  window.addEventListener('resize', this._onResize);
	  GalleryStore.addChangeListener(this._onChange);
	  $(document.body).on('keydown.galleryapp', this._onKeyDown);

	  if (!window.history.state || (window.history.state.gallery || '') !== document.location.href) {
	    window.history.pushState({
	      gallery: document.location.href,
	    }, document.title, window.location.href);
	  }
	  window.addEventListener('popstate', this.props.onClose);

	  this.setSize();
	}

	componentWillUnmount() {
	  window.removeEventListener('resize', this._onResize);
	  GalleryStore.removeChangeListener(this._onChange);
	  $(document.body).off('keydown.galleryapp', this._onKeyDown);

	  window.removeEventListener('popstate', this.props.onClose);
	  if (window.history.state && (window.history.state.gallery || '') === document.location.href) {
	    window.history.back();
	  }
	}

	// Aprēķin augstumus
	setSize = () => {
	  const galleryMain = ReactDOM.findDOMNode(this.refs.GalleryBoxMain);
	  const galleryThumbs = ReactDOM.findDOMNode(this.refs.GalleryBoxThumbs);
	  const windowHeight = $(window).height();

	  let mainHeight = null;

	  let thumbs = true;
	  if (windowHeight < 400) {
	    thumbs = false;
	    mainHeight = windowHeight;
	  } else {
	    mainHeight = windowHeight - 100;
	    if (mainHeight > 668) {
	      mainHeight = 668;
	    }
	  }

	  if (this.state.mainHeight != mainHeight || this.state.thumbs != thumbs) {
	    this.setState({
	      mainHeight,
	      thumbs,
	    });
	  }
	};

	render() {
	  const self = this;
	  const divStyleMain = {
	    height: this.state.mainHeight,
	  };

	  const Thumbs = function () {
	    // ja State thumbs nav true, tad nerāda
	    if (!self.state.thumbs) {
	      return (<div />);
	    }

	    return (
  <div>
    <GalleryBoxThumbs ref="GalleryBoxThumbs" />
  </div>
	    );
	  };

	  return (
  <div className="galleryContainer" onClick={self._onClick}>
    <div
      key={this.state.load}
      className={cx([
							'galleryContainer-loader',
							['hide', !this.state.load], // kad dati ielādēti, paslēpt loader
						])}
    >
      <Loader large center />
    </div>
    <div className="galleryContainer-box">
      <div style={divStyleMain}>
        <GalleryBoxMain
          ref="GalleryBoxMain"
          onClose={this.props.onClose}
          showReportButton={this.props.showReportButton}
          showLikeButton={this.props.showLikeButton}
          showComplimentButton={this.props.showComplimentButton}
        />
      </div>
      {Thumbs()}
    </div>
  </div>
	  );
	}

	/**
	* Event handler for 'change' events coming from the stores
	*/
	_onChange = () => {
	  this.setState(getStateFromStores());
	};

	/**
	* Event handler for 'resize'
	*/
	_onResize = () => {
	  this.setSize();
	};

	/**
	* Event handler for 'onKeyDown'
	*/
	_onKeyDown = (event) => {
	  // aizvērt, ja nospiests ESC
	  if (event.keyCode == 27) {
	    this.props.onClose();
	  }
	};

	/**
	* Event handler for 'onClick'
	*/
	_onClick = (e) => {
	  e.preventDefault();
	  this.props.onClose();
	};
}

module.exports = GalleryApp;
